import React from "react";
import Skeleton from "react-loading-skeleton";
import { skeletonBaseColor, skeletonHighlightColor } from "../../utils/constants";

export default function HomeStoryCardSkeleton() {
  return (
    <div className="homeStoryCard homeStoryCardWidth pointer rounded mx-2 px-2 py-3 px-lg-4 text-start">
      <div className="d-flex justify-content-center">
        <Skeleton
          circle
          className="img-small"
          baseColor={skeletonBaseColor}
          highlightColor={skeletonHighlightColor}
          width={40}
        />
      </div>
      <Skeleton
        className="my-3"
        height={30}
        baseColor={skeletonBaseColor}
        highlightColor={skeletonHighlightColor}
      />
      <Skeleton
        className=""
        count={4}
        baseColor={skeletonBaseColor}
        highlightColor={skeletonHighlightColor}
      />
    </div>
  );
}
